__turbopack_context__.v({
  "btnSaveCont": "TaxIdentificationNumberInfo-module-scss-module__b5NA9q__btnSaveCont",
  "data-identification": "TaxIdentificationNumberInfo-module-scss-module__b5NA9q__data-identification",
  "identification-left": "TaxIdentificationNumberInfo-module-scss-module__b5NA9q__identification-left",
  "identity-inputs-wrapper": "TaxIdentificationNumberInfo-module-scss-module__b5NA9q__identity-inputs-wrapper",
  "identity-left": "TaxIdentificationNumberInfo-module-scss-module__b5NA9q__identity-left",
  "isSaved": "TaxIdentificationNumberInfo-module-scss-module__b5NA9q__isSaved",
  "wrapper": "TaxIdentificationNumberInfo-module-scss-module__b5NA9q__wrapper",
});
